import styled from 'styled-components'

export const IconImage = styled.img`
  width: ${(props) => `${props?.w}px`};
  height: ${(props) => `${props?.h}px`};
  border-radius: ${(props) => `${props?.b}px`};
`

export const DisplayFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`
